import * as React from 'react';

import PaginatedEntityTable from 'components/common/PaginatedEntityTable';
import QueryHelper from 'components/common/QueryHelper';
import { Col } from 'common/components';
import { useFetchEventProcedures } from 'security-app/hooks/useEventProceduresAPI';
import type { EntityBase } from 'components/common/EntityDataTable/types';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

import { listElements } from './constants';
import { columnRenderers } from './column-renderers';
import useTableElements from './use-table-elements';

function EventProcedureLilList() {
  const { searchEventProcedures, eventProceduresEntitiesKeyFn } = useFetchEventProcedures();
  const { expandedSections } = useTableElements();

  return (
    <Col $align="center">
      <PaginatedEntityTable<EntityBase & EventProceduresAPIType<Array<EventProcedureStepAPIType>>>
        humanName="Event Procedures Lil List"
        entityActions={null}
        columnsOrder={listElements.columnOrder}
        queryHelpComponent={<QueryHelper entityName="Event Procedure" />}
        tableLayout={listElements.defaultLayout}
        fetchEntities={searchEventProcedures}
        keyFn={eventProceduresEntitiesKeyFn}
        actionsCellWidth={0}
        entityAttributesAreCamelCase={false}
        columnRenderers={columnRenderers}
        expandedSectionsRenderer={expandedSections}
      />
    </Col>
  );
}

export default EventProcedureLilList;
